import React, { useState, useContext, useEffect } from "react";
import Col from "react-bootstrap/Col";
import AuthContext from "../../Context/AuthContext";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { Button } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import Spinner from "react-bootstrap/Spinner";
import Row from "react-bootstrap/Row";
import { ToastContainer, toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import "react-toastify/dist/ReactToastify.css";
import "./DeleteDocument.css";

function DeleteDocument() {
  const [name, setName] = useState("");
  const [userName, setUserName] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  let { pid, did } = useParams();

  const navigate = useNavigate();

  const { state } = useContext(AuthContext);

  const { t } = useTranslation();

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "post",
        url: `${process.env.REACT_APP_BACKEND_URL}/users/document/info/${did}`,
        data: { personId: pid },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setName(response.data.name);
      setUserName(response.data.userName);
    }
    fetch();
    setIsLoading(false);
  }, []);

  const handleSubmit = async () => {
    try {
      await axios({
        method: "put",
        url: `${process.env.REACT_APP_BACKEND_URL}/users/people/document/delete/${did}`,
        data: { personId: pid },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      toast(t("Personas.Persona.Documentos.Eliminar.MensajeToast"));
      setTimeout(() => {
        navigate(`/people/overview/${pid}`, {
          state: { tabKey: "documentos" },
        });
      }, 2000);
    } catch (error) {
      toast(error.response.data.message);
    }
  };

  if (isLoading) {
    return (
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  } else {
    return (
      <Container fluid>
        <Row>
          <Col className="delete-document">
            <Col>
              <h4>{t("Personas.Persona.Documentos.Eliminar.Titulo")}</h4>
            </Col>
            <ToastContainer />
            <Col className="delete-person-form">
              <Col className="mb-1">
                <p>
                  {t("Personas.Persona.Documentos.Eliminar.EstasSeguro")}{" "}
                  <strong>{`${name}`}</strong>{" "}
                  {t("Personas.Persona.Documentos.Eliminar.DelUsuario")}{" "}
                  <strong>{`${userName}?`}</strong>
                </p>
              </Col>
              <Col>
                <Button className="primary" onClick={handleSubmit}>
                  {t("Personas.Persona.Documentos.Eliminar.Confirmar")}
                </Button>
                <Button className="danger" onClick={() => navigate("/people")}>
                  {t("Personas.Persona.Documentos.Eliminar.Cancelar")}
                </Button>
              </Col>
            </Col>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default DeleteDocument;
